(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.VikisCalculatorBasket = factory();
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var productIds = ['8683949293753', '8683949326521', '8683949392057', '8683949490361', '8683949850809'];

  function text(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function identity(name, species) {
    return text(species) + ':' + text(name);
  }

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? number : null;
  }

  function inspect(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error('Invalid basket response');
    var groups = [];
    var issues = [];
    cart.items.forEach(function (item, index) {
      if (!productIds.includes(String(item.product_id)) || !(Number(item.quantity) > 0)) return;
      var properties = item.properties || {};
      var name = text(properties._vikis_pet_name || properties["Pet's name"]);
      var species = text(properties._vikis_pet_type || properties['Pet type']);
      if (!name || !['dog', 'cat'].includes(species)) {
        issues.push({ key: item.key, reason: 'missing-pet-details' });
        return;
      }
      var signature = identity(name, species);
      var id = String(properties._vikis_pet_id || 'legacy:' + signature);
      var order = positiveInteger(properties._vikis_pet_order) || positiveInteger(properties._vikis_pet_position) || positiveInteger(properties['Pet position']);
      var group = groups.find(function (pet) { return pet.id === id; });
      if (!group) {
        group = { id: id, signature: signature, order: order || Number.MAX_SAFE_INTEGER, index: index, items: [] };
        groups.push(group);
      } else if (group.signature !== signature) {
        issues.push({ key: item.key, reason: 'conflicting-pet-details' });
      }
      group.items.push(item);
    });
    groups.sort(function (a, b) { return a.order - b.order || a.index - b.index; });
    groups.forEach(function (pet, index) {
      pet.position = index + 1;
      if (pet.items.length > 1) issues.push({ petId: pet.id, reason: 'multiple-plans-for-pet' });
    });
    return {
      pets: groups,
      issues: issues,
      nextPosition: groups.length + 1,
      nextOrder: groups.reduce(function (max, pet) {
        return pet.order < Number.MAX_SAFE_INTEGER ? Math.max(max, pet.order) : max;
      }, 0) + 1
    };
  }

  function resolvePet(state, input, currentId) {
    var current = currentId && state.pets.find(function (pet) { return pet.id === currentId; });
    var signature = identity(input.petName, input.species);
    // A form can be reused for another pet without pressing Add another pet.
    if (current && current.signature !== signature) {
      current = null;
      currentId = null;
    }
    var matches = state.pets.filter(function (pet) { return pet.signature === signature; });
    var existing = current || (matches.length === 1 ? matches[0] : null);
    return {
      existing: Boolean(existing),
      ambiguous: !current && matches.length > 1,
      id: existing ? existing.id : currentId || null,
      position: existing ? existing.position : state.nextPosition,
      order: existing ? existing.order : state.nextOrder
    };
  }

  function reconciliationPlan(cart, core) {
    var state = inspect(cart);
    var changes = [];
    var issues = state.issues.slice();
    state.pets.forEach(function (pet) {
      pet.items.forEach(function (item) {
        var properties = item.properties || {};
        var categoryId = properties._vikis_category;
        var plan = properties._vikis_plan;
        var portion = Number(properties._vikis_package_grams);
        var species = text(properties._vikis_pet_type || properties['Pet type']);
        var category = (core.CATEGORY_RATES[species] || []).find(function (entry) { return entry.id === categoryId; });
        if (!category || !['full', 'mix', 'trial', 'custom'].includes(plan) || !Number.isFinite(portion) || portion <= 0) {
          issues.push({ key: item.key, reason: 'pricing-details-unavailable' });
          return;
        }
        if (!core.categoryAvailable(categoryId, portion)) {
          issues.push({ key: item.key, reason: 'category-unavailable' });
          return;
        }
        var base = core.categoryPrices(portion, category)[plan];
        var originalPrice = item.original_price == null ? item.price : item.original_price;
        if (originalPrice != null && Number(originalPrice) !== Math.round(base * 100)) {
          changes.push({ key: item.key, petId: pet.id, position: pet.position, categoryId: categoryId, plan: plan, expectedPriceJod: base });
        }
      });
    });
    return { changes: changes, issues: issues, requiresReview: changes.length > 0 || issues.length > 0 };
  }

  return { inspect: inspect, resolvePet: resolvePet, identity: identity, reconciliationPlan: reconciliationPlan };
});
